import ActiveService from  '@/service.active';
import { create, update } from '@/refference.helper';

const INVOICE_ACCOUNTS_URI = '/api/invoiceaccounts';

class companiesService extends ActiveService{
  constructor(
    $injector,
    $translates
  ){
    'ngInject';
    super($injector);
    this.$translates = $translates;
    this.currentCompany = null;
  }

  init(){

    this.collections.companies = [];
    this.collections.invoiceAccounts = [];

    let deferred = this.$q.defer();

    this.$q
      this.getInvoiceAccounts()
      .then( (data) => {
        create(this.collections.invoiceAccounts, data)
        deferred.resolve();
      });
    return deferred.promise;

  }

  getCompany(id){
    let deferred = this.$q.defer(),
        result = () => {
          const selectedCompany = (id) => {
            const cmp = this.collections.companies.find( company => company.id == id );
            if (typeof cmp.invoice_account == 'string') {
              if (cmp.invoice_account === '') {
                cmp.invoice_account = this.collections.invoiceAccounts.find(ia => ia.default_account === true);
              } else {
                cmp.invoice_account = this.collections.invoiceAccounts.find(ia => ia.uri === cmp.invoice_account);
              }
            }
            return cmp;
          }
      return deferred.resolve(selectedCompany(id));
    }
    try{
      result();
    } catch ( e ){
      this.init().then(()=> result());
    }
    return deferred.promise;
  }

  _getCompanies(){
    return this.activeGet(this.getUri())
      .then( companies => companies.objects );
  }

  getCompanies(params) {
		!params && (params = {});
    this.collections.companies = [];
    params.filter = {};

		let url = this.getUri();

		return this.$search(url, params)
			.then(companies => {
				create(
					this.collections.companies,
					companies.objects
				);
			});

	}

  getInvoiceAccounts() {
    return this.activeGet(INVOICE_ACCOUNTS_URI);
  }

  create( company ) {
    return this.activePost( this.getUri(), company )
      .then( _company => {
        this.collections.companies.push(_company);
        this.notify.set(this.$translates.get('COMPANIES_CREATE_SUCCESS'), 'success');
        return _company;
      } );
  }

}

export default companiesService;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies.service.js
 **/